import { Component, inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractDynamicDialogComponent } from '../../../components/dynamic-dialog/abstract-dynamic-dialog.component';
import { getErrorMessage } from '../../../consts/form-field-errors';
import { CompanyInfo } from '../../../model/company-information.model';
import { RepairerSitesStore } from '../repairer-sites/repairer-sites-store.component';
import { InfosGuidanceComponent } from '../../../components/infos-guidance/infos-guidance.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { BrowserAutoFillDisabledDirective } from '../../../directives/browser-auto-fill-disabled.directive';

@Component({
  selector: 'app-change-company-name',
  templateUrl: './change-company-name.component.html',
  imports: [
    InfosGuidanceComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    BrowserAutoFillDisabledDirective,
    MatError
  ]
})
export class ChangeCompanyNameComponent
  extends AbstractDynamicDialogComponent<{ companyInfo: CompanyInfo }>
  implements OnInit
{
  protected readonly getErrorMessage = getErrorMessage;

  constructor() {
    super();
  }

  #repairerSitesStore = inject(RepairerSitesStore);
  #dialogRef = inject(MatDialogRef<ChangeCompanyNameComponent>);
  #fb = inject(UntypedFormBuilder);

  get companyName(): FormControl<string> {
    return this.form.controls.companyName as FormControl<string>;
  }

  ngOnInit(): void {
    this.#initForm();
    this.dynamicDialogService.dialogRefSignal.set(this.#dialogRef);
  }

  #initForm(): void {
    const { companyName = null } = this.#repairerSitesStore.selectedRepairerSite() || {};

    this.form = this.#fb.group({
      companyName: [companyName, [Validators.required]]
    });
  }

  saveOrExecuteAction(): void {
    if (this.form.valid) {
      this.disabled.set(true);
      const companyName = this.companyName.value;
      this.#repairerSitesStore.updateCompanyName({
        id: this.#repairerSitesStore.selectedRepairerSite().id,
        companyName
      });
    }
  }
}
